//Name of app
const APP_NAME = 'TechieRank';
const GITHUB_STRING = 'github';
const SO_STRING = 'stackoverflow';
const DISPLAY_STRING_GH = 'GitHub';
const DISPLAY_STRING_SO = 'Stack Overflow';

export { APP_NAME, GITHUB_STRING, SO_STRING, DISPLAY_STRING_GH, DISPLAY_STRING_SO };
